import MatchModalContainer from './MatchModalContainer';

export default MatchModalContainer;
